import React from 'react';
import PropTypes from 'prop-types';

const SvgWrapper = ({ children, width, height, wrapperStyle, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 216 216"
    width={width}
    height={height}
    style={wrapperStyle}
    {...props}
  >
    {children}
  </svg>
);

SvgWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  wrapperStyle: PropTypes.object,
};

SvgWrapper.defaultProps = {
  width: 40,
  height: 40,
  wrapperStyle: {},
};

export default SvgWrapper;
